import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Spin, Table } from 'antd';

import { BASE_URL } from '../../utils/constants'
import api from '../../api/api';
import Layout from '../../components/Layout';
import { useLinkProfile } from '../../api/useLinkProfile';
import { LinkProfile } from '../../models';

interface Stats {
  total_link_clicks: number;
  total_links: number;
}

const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  const [stats, setStats] = useState<Stats>({ total_link_clicks: 0, total_links: 0 });
  const [loading, setLoading] = useState(true);

  const { loading: linkProfileLoading, linkProfiles, getLinkProfiles } = useLinkProfile();

  useEffect(() => {
    const fetchStats = async () => {
      try {
        // Replace with your actual API endpoint
        const response = await api.get('/v1/profile/');
        setStats(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Failed to load stats', err);
        setLoading(false);
      }
    };

    fetchStats();
    getLinkProfiles();
  }, []);

  // Link profile table columns
  const columns = [
    {
      title: 'Path',
      dataIndex: 'path',
      key: 'path',
      render: (path: string, record: LinkProfile) => (
          path === '' ? '(Main link)' : path
      ),
    },
    {
      title: 'Clicks',
      dataIndex: 'link_counter',
      key: 'link_counter',
      sorter: (a: LinkProfile, b: LinkProfile) => (a.link_counter || 0) - (b.link_counter || 0),
      // defaultSortOrder: 'descend',
    },
    // {
    //   title: 'Status',
    //   dataIndex: 'active',
    //   key: 'active',
    //   render: (active: boolean) => (
    //     <span className={`px-2 py-1 rounded-full text-xs ${active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
    //       {active ? 'Active' : 'Inactive'}
    //     </span>
    //   ),
    //   filters: [
    //     { text: 'Active', value: true },
    //     { text: 'Inactive', value: false },
    //   ],
    //   onFilter: (value: boolean, record: LinkProfile) => record.active === value,
    // },
  ];

  return (
    <Layout>
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <h1 className="text-2xl font-semibold text-gray-900">Dashboard</h1>

          {loading ? (
            <div className="flex justify-center mt-4">
              <Spin size="large" />
            </div>
          ) : (
            <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2">
              <div className="bg-white overflow-hidden shadow rounded-lg">
                <div className="px-4 py-5 sm:p-6">
                <dt className="text-sm font-medium text-gray-500 truncate">
                    Total Clicks
                  </dt>
                  <dd className="mt-1 text-3xl font-semibold text-gray-900">
                    {stats.total_link_clicks}
                  </dd>
                </div>
              </div>
              <div className="bg-white overflow-hidden shadow rounded-lg">
                <div className="px-4 py-5 sm:p-6">
                <dt className="text-sm font-medium text-gray-500 truncate">
                    Total Links
                  </dt>
                  <dd className="mt-1 text-3xl font-semibold text-gray-900">
                    {stats.total_links}
                  </dd>
                </div>
              </div>
            </div>
          )}

          <div className="mt-8 w-full">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Link Performance</h2>
            <div className="bg-white shadow rounded-lg overflow-hidden w-1/2">
              <Table
                dataSource={linkProfiles}
                columns={columns}
                rowKey="id"
                showSorterTooltip={false}
                pagination={{ pageSize: 20 }}
                loading={linkProfileLoading}
                // scroll={{ x: 'max-content' }}
                // summary={(pageData) => {
                //   let totalClicks = 0;
                //   pageData.forEach(({ link_counter }) => {
                //     totalClicks += link_counter || 0;
                //   });

                  // return (
                  //   <Table.Summary.Row>
                  //     <Table.Summary.Cell index={0} colSpan={2}>
                  //       <strong>Total</strong>
                  //     </Table.Summary.Cell>
                  //     <Table.Summary.Cell index={1}>
                  //       <strong>{totalClicks}</strong>
                  //     </Table.Summary.Cell>
                  //     <Table.Summary.Cell index={2} />
                  //   </Table.Summary.Row>
                  // );
                // }}
              />
            </div>
          </div>

          <div className="mt-8">
            <Button
              type="primary"
              onClick={() => navigate('/admin/links')}
              className="bg-blue-500 hover:bg-blue-600"
            >
              Manage Links
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard; 